export default __webpack_public_path__ + "static/N0155-c1fdae6e433ecdb3dc9cce0cf69271a4.png";